
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/release",
      function () {
        return require("private-next-pages/release.jsx");
      }
    ]);
  